var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('ckeditor',{ref:"editor",attrs:{"value":_vm.data,"config":_vm.editorConfig,"readOnly":_vm.readOnly,"editorUrl":"https://cdn.ckeditor.com/4.15.0/full-all/ckeditor.js"},on:{"input":_vm.onEditorInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }